import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="py-12 px-6 bg-cream relative overflow-hidden" data-id="element-121">
      <div className="max-w-3xl mx-auto text-center" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-123">
          <h2 className="font-cormorant italic text-3xl md:text-4xl lg:text-5xl text-burgundy-deep leading-relaxed mb-10 text-balance" data-id="element-124">
            "Mírate al espejo por un segundo. No me refiero a revisar tu
            maquillaje o tu cabello. Me refiero a mirar a la mujer que vive ahí
            dentro."
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6 text-lg md:text-xl text-charcoal/80 leading-[1.9]" data-id="element-125">
          <p data-id="element-126">
            ¿Cuándo fue la última vez que sentiste un escalofrío de placer
            genuino que no tuviera nada que ver con un logro laboral o una lista
            de tareas completada?
          </p>
          <p data-id="element-127">
            Si sientes que tu cuerpo es solo un envase de logística para
            transportar responsabilidades, agendas y facturas, no estás sola. No
            has perdido tu fuego; simplemente tu sistema nervioso bloqueó el
            acceso para protegerte del agotamiento.
          </p>
        </motion.div>
      </div>
    </section>;
}